import { CountryCode } from "../../../../settings/countries";
import { ResultViewModel } from ".";

export type AddressInfo = {
  address: string;
  city: string;
  zip: string;
};

export type PetParentInfo = {
  firstName: string;
};

export type PetInfo = {
  name: string;
};

export type AddressPageViewModel = {
  addressInfo: AddressInfo;
  country: CountryCode;
  needToIssueCard: boolean;
  petParentInfo: PetParentInfo;
  petInfo: PetInfo;
  uuid: string;
};

export const createAddressPageViewModel = (
  data: ResultViewModel | null
): AddressPageViewModel | null => {
  if (!data) return null;

  return {
    addressInfo: {
      address: data.petParent.address ?? "",
      city: data.petParent.city ?? "",
      zip: data.petParent.zip ?? "",
    },
    country: data.country,
    needToIssueCard: !data.barkibuCard.issued || !data.petParent.kbKey,
    petInfo: {
      name: data.pet.name,
    },
    petParentInfo: {
      firstName: data.petParent.firstName ?? "",
    },
    uuid: data.uuid,
  };
};
